import { gql } from "@apollo/client";

export const CREATE_PRICE_RULE = gql`
  mutation CreatePriceRuleMutation($input: CreatePriceRuleInput!) {
    createPriceRule(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_PRICE_RULE = gql`
  mutation UpdatePriceRuleMutation($id: Int!, $input: UpdatePriceRuleInput!) {
    updatePriceRule(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_PRICE_RULE = gql`
  mutation RemovePriceRuleMutation($id: Int!) {
    removePriceRule(id: $id) {
      ok
      error
    }
  }
`;

export const PRICE_RULE = gql`
  query PriceRuleQuery($id: Int!) {
    priceRule(id: $id) {
      ok
      error
      result {
        id
        productId
        customerId
        quantity
        priceCents
        createdBy {
          id
          firstname
          lastname
        }
      }
    }
  }
`;

export const PRICE_RULES = gql`
  query PriceRulesQuery($where: PriceRulesFiltersInput!) {
    priceRules(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        productId
        customerId
        quantity
        priceCents
        createdBy {
          id
          firstname
          lastname
        }
      }
    }
  }
`;
